<p-inputGroup class="leaflet-input-group">
  <p-inputgroup-addon tabindex="0" class="search-icon" [class.collapsed]="!inputExpanded()" (mousedown)="toggleExpansion()" (keydown.enter)="toggleExpansion()"
    ><i class="fas fa-search cursor-pointer font-bold"></i
  ></p-inputgroup-addon>
  <input
    #searchInput
    type="text"
    tabindex="0"
    id="googleSearch"
    [placeholder]="'shared.AddressSearchPlaceholder' | translate"
    (blur)="onInputBlur($event)"
    (keyup)="onInputChanged()"
    (mouseover)="inputMouseover()"
    (mouseout)="inputMouseout()"
    (mousedown)="focusSearchInput()"
  />
</p-inputGroup>
